/**
 * Vue global event bus
 */
export const plugin = {
    name: 'event bus',

    pluginProperties: {
        eventBus: null
    },

    install (Vue) {
        this.pluginProperties.eventBus = new Vue();
        Vue.prototype.$eventBus = this.pluginProperties.eventBus;
    }
};

export default plugin;
